import "./MemberCard.css";

import user from "../../images/user.svg"
import card_profile from "../../images/card_profile.svg"
import card from "../../images/card_front.png"
import { NavLink } from "react-router-dom";
import { ArrowRight } from 'lucide-react';
import getAvatar from "../../utils/avatarFormat"

export default function MemberCard({
    name,
    joinDate,
    cardNumber,
    onClick,
    avatarImage = user,
}) {

    return (
        <div className="member-card">
            <div className="member-card-left">
                <span className="member-card__avatar">{getAvatar(name)}</span>

                <div className="member-card-content">
                    <h3>{name}</h3>
                    <p>
                        <span>Data de admissão: </span> {joinDate}
                    </p>
                </div>
            </div>
            <div className="member-card-right" onClick={onClick}>
                <img
                    src={card}
                    alt=""
                    className="member-card-img"
                />
                <div>
                    <NavLink exact activeClassName="active" to="/cartaoassociado">
                        <div className="member-card-link">
                            <strong>Cartão de Associado</strong>
                            <ArrowRight size="16px" color="white" />
                        </div>
                    </NavLink>
                    <span>{cardNumber}</span>
                </div>
            </div>
            <div className="member-card-bottom">
                <img
                    src={card_profile}
                    alt=""
                    className="member-card-img"
                />
                <NavLink exact activeClassName="active" to="/cartaoassociado">
                    <div className="member-card-link">
                        <strong>Cartão de Associado</strong>
                        <ArrowRight size="16px" color="white" />
                    </div>
                </NavLink>
            </div>
        </div>
    );
}